/* SAEGE — "+" quick add on collection tiles + Shop the look tiles.
   Single-variant products add straight to the bag. Products with options open a small
   sheet (fetches /products/<handle>.js) so the shopper can pick the variant without leaving the page. */
(function () {
  if (window.SaegeQuickAdd) return;
  window.SaegeQuickAdd = true;

  var TICK = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 8.5l3.2 3.2L13 5"/></svg>';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var sheet = null, sheetProduct = null, sheetVariant = null, lastBtn = null;

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, (window.theme && theme.money_format) || '£{{amount}}');
    return '£' + (cents / 100).toFixed(2);
  }

  function add(variantId, btn) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function () {
      document.dispatchEvent(new CustomEvent('theme:cartchanged'));
      if (btn) {
        var html = btn.innerHTML;
        btn.classList.add('is-added');
        btn.innerHTML = TICK;
        setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = html; btn.disabled = false; }, 1500);
      }
      // close a Shop the look sheet if one is open, then show the bag
      document.querySelectorAll('.saege-stl-modal.is-open [data-saege-stl-close]').forEach(function (c) { c.click(); });
      setTimeout(function () { document.dispatchEvent(new CustomEvent('theme:open-cart-drawer')); }, 250);
    });
  }

  /* ---- variant sheet ---- */
  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'saege-qa-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="saege-qa-sheet__backdrop" data-qa-close></div>' +
      '<div class="saege-qa-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="saege-qa-title">' +
        '<span class="saege-qa-sheet__handle" aria-hidden="true"></span>' +
        '<button type="button" class="saege-qa-sheet__close" data-qa-close aria-label="Close">' +
          '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14"/></svg>' +
        '</button>' +
        '<div class="saege-qa-sheet__product">' +
          '<img class="saege-qa-sheet__img" alt="">' +
          '<div><div class="saege-qa-sheet__title" id="saege-qa-title"></div><div class="saege-qa-sheet__price"></div></div>' +
        '</div>' +
        '<div class="saege-qa-sheet__label"></div>' +
        '<div class="saege-qa-sheet__options"></div>' +
        '<button type="button" class="saege-qa-sheet__add" disabled>Add to bag</button>' +
        '<a class="saege-qa-sheet__link" href="#">View full details</a>' +
      '</div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-qa-close]')) { closeSheet(); return; }
      var chip = e.target.closest('[data-qa-variant]');
      if (chip) { selectVariant(Number(chip.getAttribute('data-qa-variant'))); return; }
      if (e.target.closest('.saege-qa-sheet__add')) {
        var b = e.target.closest('.saege-qa-sheet__add');
        if (!sheetVariant || b.disabled) return;
        b.disabled = true; b.textContent = 'Adding…';
        add(sheetVariant.id, null).then(function () {
          b.textContent = 'Added'; closeSheet();
        }).catch(function () { b.disabled = false; b.textContent = 'Try again'; });
      }
    });
    return sheet;
  }

  function selectVariant(id) {
    var v = sheetProduct.variants.filter(function (x) { return x.id === id; })[0];
    if (!v) return;
    sheetVariant = v;
    sheet.querySelectorAll('[data-qa-variant]').forEach(function (c) {
      c.classList.toggle('is-selected', Number(c.getAttribute('data-qa-variant')) === id);
    });
    var price = sheet.querySelector('.saege-qa-sheet__price');
    price.innerHTML = v.compare_at_price && v.compare_at_price > v.price
      ? '<span class="saege-qa-sheet__sale">' + money(v.price) + '</span> <s>' + money(v.compare_at_price) + '</s>'
      : money(v.price);
    if (v.featured_image && v.featured_image.src) sheet.querySelector('.saege-qa-sheet__img').src = v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2');
    var addBtn = sheet.querySelector('.saege-qa-sheet__add');
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
  }

  function openSheet(product, btn) {
    ensureSheet();
    sheetProduct = product; sheetVariant = null; lastBtn = btn;
    sheet.querySelector('.saege-qa-sheet__title').textContent = product.title;
    sheet.querySelector('.saege-qa-sheet__img').src = (product.featured_image || '').replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2');
    sheet.querySelector('.saege-qa-sheet__link').href = root + 'products/' + product.handle;
    // /products/<handle>.js returns options as strings on some stores and as {name} objects on others
    var opt0 = product.options && product.options[0];
    var optName = typeof opt0 === 'string' ? opt0 : (opt0 && opt0.name) || 'option';
    var single = product.options && product.options.length === 1;
    sheet.querySelector('.saege-qa-sheet__label').textContent = single ? 'Choose your ' + optName.toLowerCase() : 'Choose an option';
    var opts = sheet.querySelector('.saege-qa-sheet__options');
    opts.className = 'saege-qa-sheet__options' + (product.variants.length > 8 ? ' saege-qa-sheet__options--dense' : '');
    opts.innerHTML = product.variants.map(function (v) {
      return '<button type="button" class="saege-qa-sheet__chip' + (v.available ? '' : ' is-unavailable') + '" data-qa-variant="' + v.id + '">' + v.title + '</button>';
    }).join('');
    var addBtn = sheet.querySelector('.saege-qa-sheet__add');
    addBtn.disabled = true; addBtn.textContent = 'Add to bag';
    sheet.querySelector('.saege-qa-sheet__price').textContent = product.price_varies ? 'From ' + money(product.price_min) : money(product.price);
    sheet.hidden = false;
    void sheet.offsetWidth;
    sheet.classList.add('is-open');
    document.documentElement.classList.add('saege-stl-lock');
    var firstAvail = product.variants.filter(function (v) { return v.available; });
    if (firstAvail.length === 1) selectVariant(firstAvail[0].id);
  }

  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('saege-stl-lock');
    setTimeout(function () { sheet.hidden = true; }, 260);
    if (lastBtn) { lastBtn.disabled = false; if (document.contains(lastBtn)) lastBtn.focus({ preventScroll: true }); }
    lastBtn = null;
  }

  /* ---- tile button ---- */
  function handle(btn) {
    if (btn.disabled) return;
    var vid = btn.getAttribute('data-saege-qa-variant');
    btn.disabled = true;
    btn.classList.add('is-busy');
    if (vid) {
      add(vid, btn).catch(function () { btn.disabled = false; btn.classList.remove('is-busy'); });
      return;
    }
    var handleName = btn.getAttribute('data-saege-qa');
    fetch(root + 'products/' + handleName + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (p) { btn.classList.remove('is-busy'); openSheet(p, btn); })
      .catch(function (err) {
        if (window.console) console.warn('[saege-quick-add]', err);
        window.location.href = root + 'products/' + handleName;
      });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-saege-qa]');
    if (b) { e.preventDefault(); e.stopPropagation(); handle(b); }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
})();
